module.exports = __webpack_public_path__ + "static/media/pongo.f654daa8.png";